import { buildBaseCommerceAPIRequest } from '../common/base-commerce-api-request-builder.js';
export const buildQuerySuggestRequest = (id, state, navigatorContext) => {
    return {
        ...buildBaseCommerceAPIRequest(state, navigatorContext),
        query: state.querySet[id],
    };
};
